import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

/**
 * Simple wrapper around `MatSnackBar` to keep messaging consistent across the app.
 * You can inject this service wherever you need to display a brief user-facing
 * notification (success, error, info, etc.).
 */
@Injectable({ providedIn: 'root' })
export class NotificationService {
  private defaultConfig: MatSnackBarConfig = {
    duration: 3000,
    verticalPosition: 'bottom',
    horizontalPosition: 'center'
  };

  constructor(private snackBar: MatSnackBar) {}

  /**
   * Open a snackbar with a custom message.
   * @param message the text to show
   * @param action label for the action button (optional)
   * @param config additional configuration overrides
   */
  public show(message: string, action: string = 'OK', config: MatSnackBarConfig = {}) {
    this.snackBar.open(message, action, { ...this.defaultConfig, ...config });
  }

  /**
   * Helper for a success-style notification. It will add a panel class that you
   * can style globally or locally to make the message green, for example.
   */
  public success(message: string, action: string = 'OK') {
    this.show(message, action, { panelClass: ['success-snackbar'] });
  }

  /**
   * Helper for an error-style notification.
   */
  public error(message: string, action: string = 'OK') {
    this.show(message, action, { panelClass: ['error-snackbar'] });
  }
}
